import { ChevronLeft } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface BackButtonProps {
  onClick: () => void
  /** Accessible name, e.g. "Back to orders". */
  label: string
}

/** Shopify's round back button before a detail or form page's breadcrumb. */
export function BackButton({ onClick, label }: BackButtonProps) {
  return (
    <Button variant="outline" size="icon" onClick={onClick} aria-label={label} title={label}>
      <ChevronLeft />
    </Button>
  )
}
